import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const CARRIER_VALIDATE_ACTION_TYPES = keymirror({
  CARRIER_REQUESTED: null,
  CARRIER_SUCCESS: null,
  CARRIER_INVALID: null,
  CLEAR_SELECTED_CARRIER: null,
  SEARCH_SAFER: null,
  SELECT_NEW_CARRIER: null,
  VALIDATE_CARRIER: null,
})

export const validateCarrier = ({ id, updateDot, updateMc }) => ({
  validateCarrier: true,
  type: CARRIER_VALIDATE_ACTION_TYPES.VALIDATE_CARRIER,
  payload: {
    id,
    updateMc,
    updateDot,
    actionTypes: Object.keys(CARRIER_VALIDATE_ACTION_TYPES),
  },
})

export const COMPLIANCE_CHECK_ACTION_TYPES = keymirror({
  COMPLIANCE_CHECK_REQUESTED: null,
  COMPLIANCE_CHECK_SUCCESS: null,
  COMPLIANCE_CHECK_FAILURE: null,
})

export const checkCompliance = ({ carrierId, shipmentId }) => {
  const requestData = {
    endpoint: ENDPOINTS.shipments,
    id: shipmentId,
    group: `carrier_insurance_match/${carrierId}`,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(COMPLIANCE_CHECK_ACTION_TYPES),
    },
  }
}

export const SEARCH_SAFER_ACTION_TYPES = keymirror({
  REQUEST_SAFER: null,
  SAFER_SUCCESS: null,
  SAFER_FAILURE: null,
})

export const querySaferForCarrier = query => {
  const requestData = {
    endpoint: ENDPOINTS.saferCarrierLookup,
    params: { query },
  }
  return {
    type: SEARCH_SAFER_ACTION_TYPES.REQUEST_SAFER,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(SEARCH_SAFER_ACTION_TYPES),
    },
  }
}

export const clearSelectedCarrier = () => ({
  clearSelectedCarrier: true,
  type: CARRIER_VALIDATE_ACTION_TYPES.CLEAR_SELECTED_CARRIER,
})

export const selectNewCarrier = payload => ({
  type: CARRIER_VALIDATE_ACTION_TYPES.SELECT_NEW_CARRIER,
  payload,
})

export const CLEAR_COMPLIANCE = 'CLEAR_COMPLIANCE'

export const clearCompliance = () => ({ type: CLEAR_COMPLIANCE })
